import {
  CREATE_COURSE_FAILED,
  CREATE_COURSE_REQ,
  CREATE_COURSE_RESET,
  CREATE_COURSE_SUCCESS,
  DELETE_COURSE_FAILED,
  DELETE_COURSE_REQ,
  DELETE_COURSE_RESET,
  DELETE_COURSE_SUCCESS,
  LIST_COURSES_FAILED,
  LIST_COURSES_REQ,
  LIST_COURSES_SINGLE_FAILED,
  LIST_COURSES_SINGLE_REQ,
  LIST_COURSES_SINGLE_RESET,
  LIST_COURSES_SINGLE_SUCCESS,
  LIST_COURSES_SUCCESS,
  TOTAL_COURSES_COUNT_FAILED,
  TOTAL_COURSES_COUNT_REQ,
  TOTAL_COURSES_COUNT_SUCCESS,
  UPDATE_COURSE_FAILED,
  UPDATE_COURSE_REQ,
  UPDATE_COURSE_RESET,
  UPDATE_COURSE_SUCCESS,
  CAMPUS_ADD_BY_COURSES_REQ,
  CAMPUS_ADD_BY_COURSES_SUCCESS,
  CAMPUS_ADD_BY_COURSES_FAILED,
  CAMPUS_DELETE_BY_COURSES_REQ,
  CAMPUS_DELETE_BY_COURSES_FAILED,
  CAMPUS_DELETE_BY_COURSES_SUCCESS,
  CAMPUS_ADD_BY_COURSES_RESET,
} from "../Constants/courseConstant";
import axiosConfig from "../Core/axiosConfig";

export const COURSES_LISTS =
  (course_filter_data) => async (dispatch, getState) => {
    try {
      dispatch({ type: LIST_COURSES_REQ });
      let { data } = await axiosConfig.post(
        `/courses/getCourses2`,
        course_filter_data
      );

      if (data.Result.includes("Error")) {
        dispatch({ type: LIST_COURSES_FAILED, payload: data.Result });
      } else {
        dispatch({ type: LIST_COURSES_SUCCESS, payload: data.Result });
      }
    } catch (ex) {
      dispatch({ type: LIST_COURSES_FAILED, payload: `Error-${ex.message}` });
    }
  };

export const COURSE_SINGLE_DATA = (ID) => async (dispatch, getState) => {
  try {
    dispatch({ type: LIST_COURSES_SINGLE_REQ });
    let { data } = await axiosConfig.get(`/courses/${ID}`);

    if (data.Result.includes("Error")) {
      dispatch({ type: LIST_COURSES_SINGLE_FAILED, payload: data.Result });
    } else {
      dispatch({ type: LIST_COURSES_SINGLE_SUCCESS, payload: data.Result });
    }
  } catch (ex) {
    dispatch({
      type: LIST_COURSES_SINGLE_FAILED,
      payload: `Error-${ex.message}`,
    });
  }
};

export const COURSE_SINGLE_DATA_RESET = () => (dispatch) => {
  dispatch({ type: LIST_COURSES_SINGLE_RESET });
};

export const COURSES_CREATE_LIST =
  (course_data) => async (dispatch, getState) => {
    try {
      dispatch({ type: CREATE_COURSE_REQ });
      course_data.Course_Name = course_data.Course_Name.trim();
      let { data } = await axiosConfig.post(`/courses`, course_data);
      if (typeof data.Result === "number") {
        dispatch({
          type: CREATE_COURSE_SUCCESS,
          payload: data.Result,
        });
      } else {
        dispatch({ type: CREATE_COURSE_FAILED, payload: data.Result });
      }
    } catch (ex) {
      dispatch({ type: CREATE_COURSE_FAILED, payload: `Error-${ex.message}` });
    }
  };

export const COURSES_CREATE_LIST_FORM_RESET = () => (dispatch) => {
  dispatch({ type: CREATE_COURSE_RESET });
};

export const COURSES_UPDATE =
  (ID, course_data) => async (dispatch, getState) => {
    try {
      dispatch({ type: UPDATE_COURSE_REQ });
      let { data } = await axiosConfig.put(`/courses/${ID}`, course_data);
      if (data?.Result?.includes("Error")) {
        dispatch({ type: UPDATE_COURSE_FAILED, payload: data.Result });
      } else {
        dispatch({ type: UPDATE_COURSE_SUCCESS, payload: data.Result });
      }
    } catch (ex) {
      dispatch({ type: UPDATE_COURSE_FAILED, payload: `Error-${ex.message}` });
    }
  };

export const COURSES_UPDATE_RESET_FORM = () => (dispatch) => {
  dispatch({ type: UPDATE_COURSE_RESET });
};

export const COURSES_TOTAL_COUNTS =
  (course_filter_data) => async (dispatch, getState) => {
    try {
      dispatch({ type: TOTAL_COURSES_COUNT_REQ });
      let { data } = await axiosConfig.post(
        `/courses/getCourses2Total`,
        course_filter_data
      );

      if (data?.Result.includes("Error")) {
        dispatch({ type: TOTAL_COURSES_COUNT_FAILED, payload: data.Result });
      } else {
        dispatch({ type: TOTAL_COURSES_COUNT_SUCCESS, payload: data.Result });
      }
    } catch (ex) {
      dispatch({
        type: TOTAL_COURSES_COUNT_FAILED,
        payload: `Error-${ex.message}`,
      });
    }
  };

export const COURSE_LIST_DELETE = (ID) => async (dispatch, getState) => {
  try {
    dispatch({ type: DELETE_COURSE_REQ });
    let { data } = await axiosConfig.delete(`/courses/${ID}`);
    if (data.Result.includes("Error")) {
      dispatch({ type: DELETE_COURSE_FAILED, payload: data.Result });
    } else {
      dispatch({ type: DELETE_COURSE_SUCCESS, payload: data.Result });
    }
  } catch (ex) {
    dispatch({ type: DELETE_COURSE_FAILED, payload: `Error-${ex.message}` });
  }
};

export const COURSE_LIST_DELETE_RESET_FORM = () => (dispatch) => {
  dispatch({ type: DELETE_COURSE_RESET });
};

export const ADD_CAMPUS_BY_COURSE =
  (Campus_Data) => async (dispatch, getState) => {
    try {
      dispatch({ type: CAMPUS_ADD_BY_COURSES_REQ });
      let { data } = await axiosConfig.post(
        `/campus/AddCampusOnCourse`,
        Campus_Data
      );
      if (data.Result.includes("Error")) {
        dispatch({ type: CAMPUS_ADD_BY_COURSES_FAILED, payload: data.Result });
      } else {
        dispatch({ type: CAMPUS_ADD_BY_COURSES_SUCCESS, payload: data.Result });
      }
    } catch (ex) {
      dispatch({
        type: CAMPUS_ADD_BY_COURSES_FAILED,
        payload: `Error-${ex.message}`,
      });
    }
  };

export const ADD_CAMPUS_BY_COURSE_RESET = () => (dispatch) => {
  dispatch({ type: CAMPUS_ADD_BY_COURSES_RESET });
};

export const CAMPUS_DELETE_ALL = (course_Id) => async (dispatch, getState) => {
  try {
    dispatch({ type: CAMPUS_DELETE_BY_COURSES_REQ });
    let { data } = await axiosConfig.delete(
      `/campus/AddCampusOnCourse2/${course_Id}`
    );

    if (data.Result.includes("Error")) {
      dispatch({ type: CAMPUS_DELETE_BY_COURSES_FAILED, payload: data.Result });
    } else {
      dispatch({
        type: CAMPUS_DELETE_BY_COURSES_SUCCESS,
        payload: data.Result,
      });
    }
  } catch (ex) {
    dispatch({
      type: CAMPUS_DELETE_BY_COURSES_FAILED,
      payload: `Error-${ex.message}`,
    });
  }
};
